import { Link } from "react-router-dom";
import responsiveDevices from "../../assets/responsiveDevices.png";
import pixQrCode from "../../assets/pixQrCode.svg";
import { LinkOption } from "../../components/LinkOptions";

export function AuthorizedDevices() {
  return (
    <section className="flex items-start justify-start gap-7 flex-col px-7 py-11">
      <div className="space-y-7 text-center">
        <h4 className="text-3xl font-bold">Ações</h4>
        <div className="flex items-center justify-start flex-wrap gap-7">
          <Link to="/wallet/security-devices/access-list-authorizer">
            <LinkOption title="Meus Dispositivos" icon={responsiveDevices} />
          </Link>
          <Link to={"/wallet/security-devices/enable"}>
            <LinkOption title="Habilitar Dispositivo" icon={responsiveDevices} />
          </Link>
        </div>
      </div>
      <div className="flex items-center justify-start flex-wrap gap-7">
        <p className="text-zinc-400 text-2xl">
          Lembre-se que você pode ter até 3 dispositivos <br />
          autorizados simultaneamente
        </p>
      </div>
    </section>
  );
}
